module.exports = __webpack_public_path__ + "static/media/5-d_old.56b87bdd.png";